<div class="exercice-steps">
  @for (stepNumber of stepArray(); track $index) {
    <div class="step" [class.active]="$index <= currentStepNumber()"></div>
  }
</div>
